import { User, UserProps } from "./User";
import { useRouteMatch } from 'react-router-dom'

export const UserRoute = (props: Omit<UserProps, "userId">) => {
    const match = useRouteMatch<{ userId: string }>()

    return <User userId={match.params.userId} {...props} />
}